import { memo } from "react";
import { SystemBanner } from "../SystemBanner";

import door from "./images/403-door.png";

import styles from "./styles.module.scss";

export const AccessDeniedBlock = memo(() => {
  return (
    <SystemBanner
      image={<img className={styles.image} src={door} alt={"403"} />}
      title="Error 403"
      subTitle="Access forbidden"
      text="You don't have permission to access this page"
    />
  );
});

export default AccessDeniedBlock;